/* eslint-disable prettier/prettier */
import { api } from './axios';

export const AuthService = {
  login: (email: string, password: string) => {
    return api.post(
      '/auth/login',
      { email, password },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    ); },

  getMe: () => {
  return api.get('/auth/me', {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, },
  });
},

 
};
